import env from './env';

const APP_URL = env('POS_APP_URL') || '';

const getAppURL = () => {
  const host = window.location.origin.split('.');
  const getDomain = host.splice(-2).join('.');
  const testServers = env('POS_TEST_SERVERS')?.split(',');

  if (testServers?.includes(getDomain)) {
    return window.location.origin;
  }

  return APP_URL;
};

export default getAppURL;
